import React, { useState } from 'react';

import './index.scss';

export interface StickyLabelProps {
  text: string;
}

/**
 * Rótulo da coluna congelada. Nasce truncado em 2 linhas dentro do teto de largura e expande
 * ao toque — no celular não existe hover, então `title` não resolveria.
 */
export default function StickyLabel({ text }: StickyLabelProps) {
  const [expanded, setExpanded] = useState(false);

  // Sem texto não há o que expandir — um <button> aqui não teria nome acessível.
  // Renderiza um <span> não-interativo em vez do botão.
  if (!text) {
    return <span className="sticky-label-text">{text}</span>;
  }

  return (
    <button
      type="button"
      className="sticky-label"
      aria-expanded={expanded}
      onClick={() => setExpanded((previous) => !previous)}
    >
      <span className={`sticky-label-text${expanded ? ' sticky-label-text-expanded' : ''}`}>
        {text}
      </span>
    </button>
  );
}
